import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect } from 'react'
import FaqCard from './faq-card'
import usePopupUrl from '../../hooks/use-popup-url'
export default function Faqs({faqs}) {

    useEffect(() =>{
        const params = new URLSearchParams(document.location.search);
        const section = params.get('section')
        if (section === 'faqs') {
             document.querySelector('#faqs').scrollIntoView() 
        }
    },[])

    const [currentPopUp,setCurrentPopup] = usePopupUrl()
    return (
        <div id='faqs' className='mb-[250px]'>
            <div className='mb-[85px] flex'>
            <div className="flex flex-col">
                <h2 className='mb-[5px]'>
                    FAQS
                </h2>
             
                <StaticImage alt=''  layout='fullWidth' src='../../images/faq-gradient.png'/>
               
            </div>
            </div>
            <div className="grid grid-cols-3 grid-rows-2 gap-x-[20px] gap-y-[20px] md:grid-cols-1  md:gap-x-[10px]  md:gap-y-[15px] ">
                {faqs.map((faq,index) =>{

                   return <FaqCard key={index} setOpen={setCurrentPopup} open={(currentPopUp === faq.link?.toLowerCase().trim())} faq={faq}/>
                })}
            </div>
        </div>
    )
}
